export default {
  GET_ALL_EMAIL_TEMPLATE(state, payload) {
    state.getAllEmailTemplate = payload;
  },
  GET_EMAIL_CONFIG(state, payload) {
    state.getEmailConfig = payload;
  },
  EMAIL_TYPE(state, payload) {
    state.emailType = payload;
  },
  SMS_TYPE(state, payload) {
    state.smsType = payload;
  },
};
